import { Button, Color, Icon, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackDemoInvoiceEditor } from '../../hooks/useTrackDemoInvoiceEditor'
import * as Styled from './styles'

interface DemoInvoiceBannerProps {
  onClose: () => void
  onReset: () => void
}

export const DemoInvoiceBanner = ({ onClose, onReset }: DemoInvoiceBannerProps): ReactElement => {
  const { t } = useTranslation()
  const { trackDemoInvoiceEditor } = useTrackDemoInvoiceEditor()

  const handleResetClick = useCallback(() => {
    trackDemoInvoiceEditor('Reset demo clicked')
    onReset()
  }, [onReset, trackDemoInvoiceEditor])

  const handleCloseClick = useCallback(() => {
    trackDemoInvoiceEditor('Close clicked')
    onClose()
  }, [onClose, trackDemoInvoiceEditor])

  return (
    <Styled.BannerWrapper>
      <Styled.MessageWrapper>
        <Icon color={Color.Black} icon="mousePointerClick" size="lg" />
        <Styled.MessageContent>
          <Text variant="bodyMD" weight="semiBold">
            {t('demo_invoice.banner.message_bold')}
          </Text>
          <Text variant="bodyMD">{t('demo_invoice.banner.message_detail')}</Text>
        </Styled.MessageContent>
      </Styled.MessageWrapper>
      <Button color="accent" icon="refresh" onClick={handleResetClick} variant="onColor">
        {t('demo_invoice.banner.reset')}
      </Button>
      <Button color="accent" icon="x" onClick={handleCloseClick} variant="onColor">
        {t('demo_invoice.banner.close')}
      </Button>
    </Styled.BannerWrapper>
  )
}
